module.exports = __webpack_public_path__ + "img/symbols.42072f91.svg";